document.addEventListener('alpine:init', () => {
    /** google maps can't sync with this.markers and this.markerClusterer
     * so we have to initialize these two variables outside the component
     * otherwise, we can't remove markers and markerClusterers when filtering the results
     */
    let markerClusterer = null;
    let markers = [];
    window.Alpine.data('accountantDirectory', (config) => ({
        accountants: [],
        allAccountants: [],
        basePath: config.basePath,
        statusDropdownData: JSON.parse(config.statusDropdownData),
        chosenStatus: {},
        filter_name: '',
        filter_city: '',
        preferredPartner: false,
        mapOptions: {},
        map: null,
        infoWindow: {},
        language: config.language,
        partner_link: config.partner_link,
        showAllAccountantsInList: true,
        accountantsLoading: false,
        translation: config.translation,
        changedFilterValues: {
            ['@multi-select-on-change.window'](event) {
                if (event.detail.fieldName === 'all_partner') {
                    if (Object.keys(event.detail.values).length > 0) {
                        this.chosenStatus = event.detail.values;
                    } else {
                        this.chosenStatus = this.statusDropdownData;
                    }
                    this.filterItems();
                }
            },
            ['@text-name-changed.window'](event) {
                this.filter_name = event.detail.value.toLowerCase();
                this.filterItems();
            },
            ['@text-city-changed.window'](event) {
                this.filter_city = event.detail.value.toLowerCase();
                this.filterItems();
            },
            ['@lightswitch-changed.window'](event) {
                this.preferredPartner = event.detail.value === 'checked';
                this.filterItems();
            },
        },
        init() {
            this.accountantsLoading = true;
            this.setMapOptions();
            this.initMap();
            this.loadEntries();
        },
        loadEntries() {
            window.getRequest({
                params: {
                    action: '/app-accountant/app-accountant/load-accountants',
                },
            }).then((response) => {
                this.allAccountants = response.data;
                this.accountants = response.data;
                if (this.accountants.length > 12) {
                    this.showAllAccountantsInList = false;
                }
                this.updateMarkers();
            });
        },
        showAllAccountants() {
            this.showAllAccountantsInList = true;
        },
        filterItems() {
            this.accountants = this.allAccountants
                // text filter
                .filter((item) => {
                    if (this.filter_name === '' || item.company_name.toLowerCase().indexOf(this.filter_name.toLowerCase()) > -1) {
                        return item;
                    }
                })
                // city filter
                .filter((item) => {
                    if (this.filter_city === '' || item.city.toLowerCase().indexOf(this.filter_city.toLowerCase()) > -1) {
                        return item;
                    }
                })
                // status filter
                .filter((item) => {
                    let countChosenStatus = Object.keys(this.chosenStatus).length;
                    let isEmptyOrAllSelected = countChosenStatus === 0 || countChosenStatus === Object.keys(this.statusDropdownData).length;
                    if (isEmptyOrAllSelected || Object.keys(this.chosenStatus).includes(item.status)) {
                        return item;
                    }
                })
                // preferred partner filter
                .filter((item) => {
                    if (!this.preferredPartner) {
                        return item;
                    }
                    if (this.preferredPartner && item.is_preferred_partner) {
                        return item;
                    }
                });

            this.updateMarkers();
        },
        resetFilters() {
            /* reset all three filters via event, so the original form filter fields know about the new value too
               order: resetFilters() -> value is changed on field -> because the value is changed on the field,
               the events multidropdown-filter-changed, lightswitch-changed and filter-name-changed are triggered
               which update the local filter variables: statusDropdownData, preferredPartner and filter_name
             */
            window.dispatchEvent(new CustomEvent('reset-status-filter', {
                detail: {
                    fieldName: 'all_partner',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));
            window.dispatchEvent(new CustomEvent('reset-name-filter', {
                detail: {
                    value: '',
                }
            }));
            window.dispatchEvent(new CustomEvent('reset-city-filter', {
                detail: {
                    value: '',
                }
            }));
            window.dispatchEvent(new CustomEvent('reset-preferred-partner', {
                detail: {
                    value: '',
                }
            }));

            // statusDropdownData
            this.chosenStatus = this.statusDropdownData;
            this.filter_name = '';
            this.filter_city = '';
            this.preferredPartner = false;

            this.filterItems()
        },
        initMap() {
            this.map = new google.maps.Map(document.getElementById('map'), {
                zoom: this.mapOptions.defaultZoom,
                center: new google.maps.LatLng(
                    this.mapOptions.center.lat,
                    this.mapOptions.center.lng,
                ),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                maxZoom: this.mapOptions.maxZoom,
                minZoom: this.mapOptions.minZoom,
                disableDefaultUI: this.mapOptions.disableDefaultUI,
                zoomControl: this.mapOptions.zoomControl,
                scrollwheel: this.mapOptions.scrollwheel,
            });
            /* create cluster markerer:
                https://github.com/googlemaps/js-markerclusterer
                renderer function is used to define a custom cluster image
             */
            markerClusterer = new window.googleMapsClusterer.MarkerClusterer({
                map: this.map,
                markers: markers,
                algorithm: new window.googleMapsClusterer.SuperClusterAlgorithm({}),
                renderer: {render: ({ count, position }, stats) => {
                    const strokeColor = '#6db53d';
                    const fillColor = '#0a4859';

                    const svg = window.btoa(
                        `<svg fill="${fillColor}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                            <circle cx="25" cy="25" opacity=".8" r="23" stroke="${strokeColor}" stroke-width="4" />
                        </svg>`
                    );

                    const clusterDiameterOnDisplayInPx =  (count > 10) ? 45 : 35;
                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: `data:image/svg+xml;base64,${svg}`,
                            scaledSize: new google.maps.Size(clusterDiameterOnDisplayInPx, clusterDiameterOnDisplayInPx),
                        },
                        label: {
                            text: String(count),
                            color: "white",
                            fontSize: "12px",
                        },
                        // adjust zIndex to be above other markers
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    });
                }
            }});

            google.maps.event.addListener(this.map, 'mousemove', () => {
                if (Object.keys(this.infoWindow).length) {
                    this.infoWindow.close();
                }
            });

            // Closes infoWindow if clicked on a cluster => important for mobile UX
            google.maps.event.addListener(markerClusterer, 'click', () => {
                if (Object.keys(this.infoWindow).length) {
                    this.infoWindow.close();
                }
            });
        },
        updateMarkers() {
            this.resetMarkers();
            if (this.accountants.length === 0) {
                this.map.setCenter(
                    new google.maps.LatLng(
                        this.mapOptions.center.lat,
                        this.mapOptions.center.lng,
                    ),
                );
                this.map.setZoom(this.mapOptions.defaultZoom);

                return;
            }

            // create new markers with info windows
            Object.values(this.accountants).forEach((item) => {
                const ltng = new google.maps.LatLng(
                    item.latitude,
                    item.longitude,
                );

                const icon = {
                    url: item.is_preferred_partner
                        ? `${this.basePath}/img/accountant-directory/images/pin-blue.svg`
                        : `${this.basePath}/img/accountant-directory/images/pin-green.svg`,
                    scaledSize: new google.maps.Size(29, 43),
                };

                const marker = new google.maps.Marker({
                    position: ltng,
                    optimized: true,
                    icon,
                });

                marker.addListener('mouseover', () => {
                    if (Object.keys(this.infoWindow).length) {
                        this.infoWindow.close();
                    }

                    let langList = '';
                    for (let i = 0; i < item.languages.length; i++) {
                        langList += `<li class="pl-0 bg-bg-petrol-900 rounded-full text-white inline-block text-xs h-8 w-8 leading-xs text-center uppercase mr-1 before:hidden pt-2 first-of-type:ml-0 ml-3">${item.languages[i]}</li>`;
                    }

                    let contentString = `<div class="py-1 pl-1.5">
                                            <div class="flex border-b border-petrol-600 mb-2 pb-2">
                                                <div class="inline w-96 mb-0">
                                                    <div class="text-xl font-bold nowrap overflow-ellipsis overflow-hidden">${item.company_name ? item.company_name : `${item.firstname} ${item.lastname}`}</div>
                                                    <div class="text-petrol-600 text-xs">${item.address}, ${item.postcode} ${item.city}</div></div>`;

                    if (item.status !== 'nostatus') {
                        const imageUrls = {
                            normal: `https://cdn.bexio.com/logo/accountant/badge/${this.language}/${item.status}-def-${this.language}.svg`,
                            preferred: `https://cdn.bexio.com/logo/accountant/badge/${this.language}/${item.status}-pre-${this.language}.svg`,
                        };

                        const imgString = item.is_preferred_partner
                            ? `<img class="w-9 h-9 ml-auto" alt="${item.status}" src="${imageUrls.preferred}"/>`
                            : `<img class="w-9 h-9 ml-auto" alt="${item.status}" src="${imageUrls.normal}" />`;
                        contentString += imgString;
                    }

                    contentString +=
                        `</div><div>

                            <div class="flex">
                                <a class="h-fit-content mr-auto self-center text-base link-icon-left" href="${item.detail_url}" data-track-element="bexio.accountant_directory_overview_map.${item.company_name_snakecase}${item.preferredTracking}">${this.translation.detail_view}</a>
                                <ul class="pl-0 inline-block mb-0">${langList}</ul>
                            </div>
                        </div>
                    </div>`;

                    this.infoWindow = new google.maps.InfoWindow({
                        content: contentString,
                    });

                    this.infoWindow.open({
                        anchor: marker,
                        shouldFocus: false,
                    });
                });
                markers.push(marker);
            });
            markerClusterer.addMarkers(markers);
            markerClusterer.render();

            if (this.accountantsLoading) {
                this.accountantsLoading = false;
            }

        },
        setMapOptions() {
            this.mapOptions = {
                center: {
                    lat: 47.228698,
                    lng: 8.831764,
                },
                maxZoom: 17,
                minZoom: 4,
                defaultZoom: 8,
                disableDefaultUI: true,
                zoomControl: true,
                scrollwheel: false,
            }
        },
        resetMarkers() {
            markerClusterer.clearMarkers(true);
            markers = [];
        },
    }))
})
